<template>
  <div class="resource-cate">
    <div class="cate-left">{{$t('global.sort1')}}：</div>
    <div class="cate-right">
      <ul>
        <li
          v-for="item in itcVideoCate"
          :key="item.id"
          @click="selectCate(item.id, item, 1)"
        >
          <span :class="activeClass==item.id?'cate-active':''">{{item.name}}</span>
        </li>
      </ul>
    </div>
    <br style="clear:both;" />
    <div
      class="cate-left"
      v-if="itcVideoCate2.length"
    >{{$t('global.sort2')}}：</div>
    <div class="cate-right">
      <ul>
        <li
          v-for="item in itcVideoCate2"
          :key="item.id"
          @click="selectCate(item.id, item, 2)"
        >
          <span :class="activeClass2==item.id?'cate-active':''">{{item.name}}</span>
        </li>
      </ul>
    </div>
    <br style="clear:both;" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      itcVideoCate: [],
      itcVideoCate2: [],
      activeClass: 0,
      activeClass2: -2,
    };
  },
  created() {
    this.getItcSortData();
  },
  methods: {
    async getItcSortData() {
      let success = (res) => {
        // 此函数是为了防止自动弹出操作成功提示
      };
      let [{ data: res1 }, { data: res2 }] = await Promise.all([
        this.$ajax.get("api/video/video_cate", {
          params: {
            page_index: 1,
            page_size: 9999,
            status: 1,
            type: 1,
          },
          func: {
            success,
          },
        }),
        this.$ajax.get("api/video/video_cate", {
          params: {
            page_index: 1,
            page_size: 9999,
            status: 1,
            type: 2,
          },
          func: {
            success,
          },
        }),
      ]);
      let data1 = res1.data.data.data;
      let data2 = res2.data.data.data;
      data1.unshift(
        { id: 0, name: this.$t("global.all") },
        { id: -1, name: this.$t("global.defaultSort") }
      );
      data1.forEach((element) => {
        element.children = [{ id: -2, name: this.$t("global.all") }];
        data2.forEach((child) => {
          if (element.id === child.pid) {
            element.children.push(child);
          }
        });
      });
      // console.log(data1, data2);
      // 为页面一级分类、二级分类赋值
      this.itcVideoCate = data1;
      this.itcVideoCate2 = data1[0].children;
    },
    selectCate(val, item, type) {
      
      console.log(item)
      // 点击某个一级分类
      if (type === 1) {
        this.itcVideoCate2 = [];
        if (item.children) {
          this.itcVideoCate2 = item.children;
        }
        this.activeClass = val;
        this.activeClass2 = -2;
        this.$emit("emitListData", val);
      }
      // 点击某个二级分类
      if (type === 2) {
        this.activeClass2 = val;
        // 如果点击的是二级分类中的全部分类
        if (val === -2) {
          val = this.activeClass
        }
        this.$emit("emitListData", val);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.resource-cate {
  margin-top: 20px;
  padding-bottom: 20px;
  min-height: 50px;
  background: #ffffff;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #020202;
  line-height: 19px;

  .cate-left {
    padding: 25px;
    float: left;
    width: 6%;
  }

  .cate-right {
    width: 85%;
    float: left;

    ul li {
      display: inline-block;
      /*width: 11%;*/
      padding: 25px 30px 0 0;
      color: #666666;
      cursor: pointer;

      &:hover {
        color: #E62125;
      }

      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .cate-active {
      color: #E62125;
    }
  }
}
</style>